<template>
  <div class="voucher-function">
    <div class="voucher-function">
      <div class="voucher-img">
        <a :href="baseUrlImg + url1" target="_blank" v-if="url1">
            <img
            style="width: 100px; height: 100px"
            :src="baseUrlImg + url1"
            />
        </a>
        <div style="text-align: center">预付款凭证</div>
      </div>
      <Upload :action="baseUrl + 'uploadVoucher'"
                         :max-size="1024"
                         :format="['jpg','jpeg','png','ico']"
                         :show-upload-list="false"
                         :on-success="handleSuccess"
                         :on-format-error="handleFormatError"
                         :headers="headers"
                         style="margin:2.5rem 0 0 .5rem"
                         v-if="disabled">
                    <Button icon="ios-cloud-upload-outline">上传预付款凭证</Button>
      </Upload>
    </div>

    <div class="voucher-function" style="margin-left: 5rem">
      <div class="voucher-img">
        <a :href="baseUrlImg + url2" target="_blank" v-if="url2">
            <img
            style="width: 100px; height: 100px"
            :src="baseUrlImg + url2"
            />
        </a>
        <div style="text-align: center">尾款凭证</div>
      </div>
      <Upload :action="baseUrl + 'uploadVoucher'"
                         :max-size="1024"
                         :format="['jpg','jpeg','png','ico']"
                         :show-upload-list="false"
                         :on-success="handleSuccess1"
                         :on-format-error="handleFormatError1"
                         :headers="headers"
                         style="margin:2.5rem 0 0 .5rem"
                         v-if="disabled">
                    <Button icon="ios-cloud-upload-outline">上传尾款凭证</Button>
      </Upload>
    </div>
    <Button type="primary" class="save-button" v-if="disabled" @click="SaveHandleClick">保存</Button>
  </div>
</template>

<script>
import config from '../../../../config/index'
import { ChangeVoucher } from '../../../../api/Order'
export default {
  name: 'OrderDetailVoucher',
  props: {
    url1: String,
    url2: String,
    Payment_Voucher: String,
    Payment_Voucher2: String,
    OrderID: String,
    State: String
  },
  data () {
    return {
      baseUrl: '',
      baseUrlImg: '',
      headers: {
        Authorization: 'Bearer ' + this.$store.state.token
      }
    }
  },
  computed: {
    disabled: function () {
      if (this.State === '查看') {
        return false
      } else {
        return true
      }
    }
  },
  mounted: function () {
    this.baseUrlImg = config.baseUrl.img
    this.baseUrl = config.baseUrl.pro
  },
  methods: {
    // 上传预付款图片成功
    handleSuccess (res, file) {
      if (res.IsSuccess) {
        this.url1 = res.Data.url
        this.$Message['success']({
          background: true,
          content: '上传成功'
        })
      } else {
        this.$Message.error(res.Message)
      }
    },
    // 图片上传失败回调
    handleFormatError (file) {
      this.$Notice.warning({
        title: 'The file format is incorrect',
        desc: 'File format of ' + file.name + ' is incorrect, please select jpg or png.'
      })
    },
    // 上传尾款图片成功
    handleSuccess1 (res, file) {
      if (res.IsSuccess) {
        this.url2 = res.Data.url
        this.$Message['success']({
          background: true,
          content: '上传成功'
        })
      } else {
        this.$Message.error(res.Message)
      }
    },
    // 图片上传失败回调
    handleFormatError1 (file) {
      this.$Notice.warning({
        title: 'The file format is incorrect',
        desc: 'File format of ' + file.name + ' is incorrect, please select jpg or png.'
      })
    },
    // 点击保存按钮事件回调
    SaveHandleClick () {
      ChangeVoucher(this.url1, this.url2, this.Payment_Voucher, this.Payment_Voucher2, this.OrderID).then(res => {
        if (res.IsSuccess) {
          this.$Message['success']({
            background: true,
            content: '更新成功'
          })
        } else {
          this.$Message.error(res.Message)
        }
      })
    }
  }
}
</script>
<style scoped>
.voucher-function{
    display: flex;
    flex-direction: row;
}
.voucher-img{
    margin-left: 2rem;
    display: flex;
    flex-direction: column;
    width: 100px;
    height: 120px;
}
.save-button{
    position: absolute;
    right: 1rem;
    bottom: 2rem;
}
</style>>
